import styled from "styled-components";
import { Spacing, V2_INPUT_HEIGHT_PX } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const LocationAutocompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const LocationInput = styled.input<{
  $isFocused: boolean;
  $hasError: boolean;
}>`
  ${TypographyV2.b2}
  width: 100%;
  height: ${V2_INPUT_HEIGHT_PX}px;
  padding: 0 16px;
  border-radius: 16px;
  border: 1.5px solid
    ${(props) =>
      props.$hasError
        ? ColorV2.NegativeRed
        : props.$isFocused
          ? ColorV2.Blue1
          : ColorV2.Blue5};
  background-color: ${ColorV2.White};
  color: ${(props) => (props.$isFocused ? ColorV2.Blue1 : ColorV2.Blue5)};
  outline: none;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &::placeholder {
    color: ${(props) => (props.$isFocused ? ColorV2.Blue1 : ColorV2.Blue5)};
  }
`;

export const SuggestionContainer = styled.div`
  padding: 8px 12px;
  border-radius: 12px;

  &:hover {
    background-color: ${ColorV2.Blue7};
    cursor: pointer;
  }
  p {
    margin: 5px 0px;
  }
`;

export const LoadingWrapper = styled.div`
  margin-top: ${Spacing.sm}px;
`;
